import RawCard from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { SingleLineText, Checkbox, Button as RawButton } from '@bloomays-lib/ui.shared';
import { useState } from 'react';
import RawCardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import { InvoiceStatus } from '@bloomays-lib/types.shared';
import { styled } from '@mui/material/styles';

type ConditionnalProps =
  | {
      mode: 'customer';
      clickHandler: (force: boolean) => Promise<void>;
    }
  | {
      mode: 'supplier';
      clickHandler: (force: boolean, byPass: boolean) => Promise<void>;
    };

export type ActionInvoiceProps = {
  invoiceLabel: string;
  activityId: string;
  lastError: string;
  invoiceStatus: InvoiceStatus;
} & ConditionnalProps;

const ActionInvoice = ({
  invoiceLabel,
  activityId,
  lastError,
  invoiceStatus,
  clickHandler,
  mode,
}: ActionInvoiceProps) => {
  const [force, setForce] = useState<boolean>(false);
  const [bypass, setBypass] = useState<boolean>(false);
  return (
    <Card>
      <CardContent>
        <StyledTypo>{invoiceLabel}</StyledTypo>
        <ContainerData>
          <ContainerTextLabel>
            <CenteredSingleLineText text={`Etat : `} span={invoiceStatus} />
          </ContainerTextLabel>
          <ContainerTextLabel>
            <CenteredSingleLineText text={`ID activité :`} span={activityId} />
          </ContainerTextLabel>
          <ContainerTextLabel>
            <LeftSingleLineText text={`Erreur :`} span={lastError} sxSpan={{ whiteSpace: 'pre-line' }} />
          </ContainerTextLabel>
        </ContainerData>
      </CardContent>
      <CardActions>
        <Checkbox
          label={'Forcer la régeneration'}
          id={'force'}
          name={'force'}
          checked={force}
          onChange={(e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => setForce(checked)}
        />
        {mode === 'supplier' ? (
          <Checkbox
            label="Ne pas vérifier"
            id={'bypass'}
            name={'bypass'}
            checked={bypass}
            onChange={(e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => setBypass(checked)}
          />
        ) : undefined}
        <Button id="handleInvoice" onClick={() => clickHandler(force, bypass)} textButton="Relancer la facturation" />
      </CardActions>
    </Card>
  ) as React.ReactNode;
};

export default ActionInvoice;
export { ActionInvoice };

const Card = styled(RawCard)(() => ({
  width: '100%',
  margin: '1.5em 0',
  paddingBottom: 10,
  paddingTop: 10,
  boxShadow: '2px 2px 20px lightgrey !important',
  borderRadius: '10px !important',
}));

const StyledTypo = styled(Typography)(() => ({
  padding: '0px 0px 16px 16px',
  fontWeight: 'bold',
}));

const ContainerData = styled('div')(() => ({
  paddingLeft: 16,
}));

const CenteredSingleLineText = styled(SingleLineText)(() => ({
  display: 'flex',
  margin: '.5em 0',
}));

const LeftSingleLineText = styled(SingleLineText)(() => ({
  display: 'flex',
  margin: '.5em 0',
}));

const CardActions = styled(RawCardActions)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
}));

const ContainerTextLabel = styled('div')(() => ({
  display: 'flex',
}));

const Button = styled(RawButton)(({ theme }) => ({
  border: 'none',
  padding: '0.7em 1.4em',
  marginRight: 10,
  borderRadius: '8px',
  backgroundColor: theme.palette.red[60],
  color: theme.palette.neutral.white,
  boxShadow: '2px 2px 5px rgb(201, 201, 201)',
  paddingRight: '16px',
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: theme.palette.neutral.white,
    color: theme.palette.blue[60],
    transition: '0.52s ease',
  },
}));
